// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> dietz-property-group-preferred -> pierpont
// Generated: 2026-08-12T21:07:50.262Z
// Counts: 4 design, 57 content, 7 slot group, 7 collection binding, 9 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=55/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://repli360.com"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp"
      }
    }
  },
  "scheduleatour.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-b030-77e6-bf9c-9fa74ca8ddab.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_ed096c4d-bf79-477a-afc4-c43258a71dfe",
      "custom_1bbaf443-d86f-45e1-9981-17a2b602cb1f"
    ],
    "orderedIds": [
      "custom_ed096c4d-bf79-477a-afc4-c43258a71dfe",
      "custom_1bbaf443-d86f-45e1-9981-17a2b602cb1f",
      "custom_ba1e0956-1159-489a-be1f-d9e962c2d257",
      "custom_af45a9f2-81de-4d6e-9d3e-525c5e59504c",
      "custom_dd412b1e-33a6-4fef-8e21-3d66c66bd975",
      "custom_8b645022-152f-47a2-9255-b86a2417849d",
      "custom_9d192bdd-42cf-45ab-804d-6867fc1ee1a9",
      "custom_26f24f1b-9963-4043-b04f-1df34989ac19",
      "custom_11e927c0-08d4-4bce-8b08-4a42befe9495",
      "custom_be61b841-61f1-4143-9910-aa04af7c4d44",
      "custom_130081c9-8725-47c5-9240-58b5074fb537",
      "custom_56d75e7d-a56b-4ac2-ae4b-6e1bbcb35871",
      "custom_b39f645a-498f-4f8b-843c-da4d6f7a7392",
      "custom_e05a8ce9-d1f6-41b5-b993-f69468cd605a",
      "custom_0e87c253-1074-4895-80e5-768d143fc70d",
      "custom_62ecc7d8-8c24-4f8a-ba1f-26dda28431f6",
      "custom_2bd6697b-6b24-4279-9e89-6e5ff0ad40bd",
      "custom_ddfab339-7710-44be-bee8-be7fc980556c",
      "custom_02340cf8-a24f-4cfd-a90f-b6df53793c19",
      "custom_3de896be-02e8-40e3-befd-adb1b8bc2c51",
      "custom_d9611548-6527-4e23-9ec0-d76b25d82a5b",
      "custom_143302e9-8f8b-4df0-b249-6b69827c565e",
      "custom_b49d8f6d-9262-4789-b9bd-5407976cbb87",
      "custom_274b805c-2eb0-43b3-8c36-430c1643b1f3",
      "custom_06a7a230-a238-4f81-807c-09cadf6b7e31",
      "custom_f0d9c008-9618-48ea-88e1-2da34dbe41eb",
      "custom_3677b471-2ff1-4c03-8a5a-416270af1e47",
      "custom_1555cba6-1b28-45dc-b658-97f664536018",
      "custom_fccaaccf-a9e1-4384-90f4-d386d3a690d2",
      "custom_2dad3dc7-c4a9-44a0-ad0c-b2de822323a1",
      "custom_7c1c1fa6-853a-4975-a734-8a7b4e985f31",
      "custom_90ee8a52-a31b-446a-8b85-4ac5c1382100",
      "custom_917568bb-4f40-40ef-9a3c-f469ab593f26",
      "custom_e46b0ee3-4650-474c-977c-f7fb24fa6b8f",
      "custom_a5dedb2b-296c-4d67-8b99-6a22603cd490",
      "custom_4d5f7502-ca2c-4dba-940a-82b35efa98bf",
      "custom_2fd0e861-a0ec-4950-972d-cd00adeccef6",
      "custom_915673af-6127-4f1a-b272-fc86d9cc5601",
      "custom_4c32fdae-8617-49d8-ba43-cd611cfb9e88",
      "custom_7dfe465d-ad8e-47ea-b7ed-1dadf26b81ed",
      "custom_4c5ab3b3-f77d-4ee6-8edc-5b96eaeeba0a",
      "custom_8466c096-412e-48cb-9b05-9b085bfb849f",
      "custom_008afdad-66d3-429f-946a-1737a1312ecb",
      "custom_425cbcc8-687d-4e0b-a437-a280e8daac46",
      "custom_98e15591-098a-4079-a2af-4cf091205cbe"
    ],
    "hiddenIndices": [
      0,
      1
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "ec_6a842ed1b288f1397704b8b4",
      "ec_591a02779c90e1d9bd7b2d04",
      "ec_57ee37c6a06637f07e278a8e"
    ],
    "orderedIds": [
      "custom_71bb8904-23bf-4e1a-8b83-279a19c8aa1e",
      "custom_ab4b7b16-5d1a-4856-9ddc-04ddad979628",
      "custom_7055e1b3-a4b2-402c-a3b7-b1951f037280",
      "custom_e21e46a5-dde5-40e8-9939-9ea1a01af1ba",
      "custom_183d4b72-3559-4cff-8ba3-1526b8444ea1",
      "custom_c95e7050-4f46-4ce9-a2c9-ff3b7343aa5e",
      "custom_0857ab92-37a4-4083-be15-f15199e1ff96",
      "custom_8f8924c8-40dd-4ed3-8814-1b7f7ff7045d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_98e15591-098a-4079-a2af-4cf091205cbe"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      44
    ],
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": null,
    "hiddenIds": [
      "ec_6a842ed1b288f1397704b8b4",
      "ec_591a02779c90e1d9bd7b2d04",
      "ec_57ee37c6a06637f07e278a8e"
    ],
    "orderedIds": [
      "custom_71bb8904-23bf-4e1a-8b83-279a19c8aa1e",
      "custom_ab4b7b16-5d1a-4856-9ddc-04ddad979628",
      "custom_7055e1b3-a4b2-402c-a3b7-b1951f037280",
      "custom_183d4b72-3559-4cff-8ba3-1526b8444ea1",
      "custom_c95e7050-4f46-4ce9-a2c9-ff3b7343aa5e",
      "custom_0857ab92-37a4-4083-be15-f15199e1ff96",
      "custom_8f8924c8-40dd-4ed3-8814-1b7f7ff7045d",
      "custom_e21e46a5-dde5-40e8-9939-9ea1a01af1ba"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_22c3c264-8fa0-4cec-a627-4d14c96ce4ff",
      "custom_59745504-11d1-4404-b17c-f3cdb155fe76",
      "custom_8f996c31-d807-4470-bdda-ddd74161e3ed",
      "custom_9b79288f-82f0-495a-9668-3f81ffa016ee",
      "custom_e3f424fe-46b4-46ed-ae91-1b04c184cbe1",
      "custom_56abc074-1306-4b8e-a680-be2a72e061a1",
      "custom_94d53a9a-5478-481b-9f01-e2b3984131b5",
      "custom_2f1c0245-0614-4c96-ab79-58bcfdf75274",
      "custom_9c9db002-83d7-4011-a48f-759e79582060"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 10
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
